import React from 'react';
import { Filter, ReferenceInput, TextInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';

const PersonalityQuizReportsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Personality quizzes" source="pack_id" reference="admin/personality-quizzes" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput label="User ID" source="user_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default PersonalityQuizReportsFilter;
